// src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAN1XYjV9vWdq5Mqo7R-SdoN1190hRP6k4",
  authDomain: "lorrens-makeup.firebaseapp.com",
  projectId: "lorrens-makeup",
  storageBucket: "lorrens-makeup.firebasestorage.app",
  messagingSenderId: "333560342090",
  appId: "1:333560342090:web:88f34d1b0e18b15017e8b3",
  measurementId: "G-H7KZXPHTFY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

export { app, analytics, auth, db, functions };